export const MENU_ITEMS = {
  pos: {
    name: 'Điểm bán hàng',
    items: [
      { name: 'Bán hàng', link: '/pos', state: { full: true, header: true } },
      { name: 'Phiên', link: '/pos-registers' },
      { name: 'Lịch sử', link: '/pos-orders' },
      { name: 'Bác sĩ', link: '/doctors' },
      { name: 'Chuyên khoa', link: '/specializations', permission: 'viewSpecializationList' },
      { name: 'Hoá đơn điện tử', link: '/einvoices' },
      { name: 'Thiết lập', link: '/pos-settings', permission: 'viewPOSSettingList' },
    ],
  },
  product: {
    name: 'Sản phẩm',
    items: [
      { name: 'Danh sách', link: '/products', permission: 'viewProductList' },
      { name: 'Danh mục', link: '/categories', permission: 'viewCategoryList' },
      { name: 'Nhãn', link: '/tags', permission: 'viewTagList' },
      { name: 'Đơn vị tính', link: '/uoms', permission: 'viewUOMList' },
      { name: 'Nhà cung cấp', link: '/vendors', permission: 'viewVendorList' },
    ],
  },
  customer: {
    name: 'Khách hàng',
    items: [
      { name: 'Danh sách', link: '/customers' },
      { name: 'Nhóm', link: '/customer-groups', permission: 'viewCustomerGroupList' },
      { name: 'Theo dõi xử lý khiếu nại', link: '/customer-complaints' },
    ],
  },
  stock: {
    name: 'Kho hàng',
    items: [
      { name: 'Kiểm kê', link: '/inventories', permission: 'viewInventoryList' },
      { name: 'Xuất hỏng', link: '/scraps', permission: 'viewScrapList' },
      { name: 'Quản lý chất lượng', link: '/quality-controls' },
    ],
  },
  report: {
    name: 'Báo cáo',
    items: [
      { name: 'Báo cáo tồn kho', link: '/report/inventory-valuations', permission: 'viewReportInventoryValuation' },
      { name: 'Sổ theo dõi bệnh nhân', link: '/patient-tracking' },
    ],
  },
};
